import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean?} State */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.MARK_ALL_AS_READ]: isLoading,
  [types.MARK_ALL_AS_READ_SUCCESS]: isEnding,
  [types.MARK_ALL_AS_READ_FAILURE]: isEnding,
});
